export default "__VITE_PUBLIC_ASSET__8673a53d__"